import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { AiFillAudio, AiOutlineAudioMuted } from 'react-icons/ai';

const DisclaimerWrapper = styled.div`
  max-width: 700px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto 2rem;
  text-align: center;
  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  button {
    padding: 1rem;
    font-size: 2.25rem;
    line-height: 0rem;
    background-color: var(--custom-dark);
    border: none;
    color: white;
    &:hover {
      cursor: pointer;
    }
    span {
      margin-top: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.25rem;
      display: block;
    }
  }
`;

const AudioDisclaimer = ({ data, enableAudio, audio }) => {
  const updateAudioState = useCallback(() => {
    enableAudio(!audio);
  }, [audio]);

  return (
    <DisclaimerWrapper>
      <p className="benton-n4">{data.audioDisclaimer}</p>
      <button type="button" onClick={() => updateAudioState()}>
        { audio ? <AiFillAudio /> : <AiOutlineAudioMuted />}
        <br />
        <span className="benton-n6">{ !audio ? 'Enable audio' : 'Disable audio' }</span>
      </button>
    </DisclaimerWrapper>
  );
};

export default AudioDisclaimer;

AudioDisclaimer.propTypes = {
  data: PropTypes.shape({
    audioDisclaimer: PropTypes.string.isRequired,
  }).isRequired,
  enableAudio: PropTypes.func.isRequired,
  audio: PropTypes.bool.isRequired,
};
